<template>
  <div
    class="app"react-beautiful-dnd
    :style="{'--brand-primary-color': brand.primaryColor}">
    <AppHeader class="d-sm-none">
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <SidebarToggler class="d-md-down-none d-none" display="lg"/>
      <b-link class="navbar-brand" to="/">
        <img
          class="navbar-brand-full"
          style="max-width: 100%; max-height: 50px;"
          :src="assetPath(brand.brandDarkLogoAsset)"
          :alt="`${brand.name} - Automated Business Insights Powered by AI`">
      </b-link>
    </AppHeader>

    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader class="d-sm-down-none">
          <img
            style="max-width: 100%; max-height: 70px;"
            :src="assetPath(brand.brandLightLogoAsset)"
            :alt="`${brand.name} - Automated Business Insights Powered by AI`">
        </SidebarHeader>
        <SidebarNav :navItems="nav"/>
        <SidebarFooter class="d-sm-down-none">
          <div class="small">Powered By <a href="https://superfluid.io" target="_blank" style="font-size:15px; color:var(--brand-primary-color); text-decoration: none">superfluid.io</a></div>
         
        </SidebarFooter>
      </AppSidebar>
      <main class="main">
        <div class="topbar">
          <div class="inner">
            <div style="display: inline-block">
               <!-- <notification-bell 
               iconColor="white"
              /> -->
              <ul style="list-style-type:none;">
                <a href="/plans" style="text-decoration: underline;">

                  <li v-if="!!free_days_left" class="mr-1 ml-1"><strong>Free trial: {{free_days_left}} days left</strong>
                  </li>
                 
                 </a>
                 <a href="/plans" style="text-decoration: underline;">
                 <i v-if="!!free_days_left" class="fa fa-hourglass-start" style="font-size:18px"></i>
                 </a>
                
                <li class="mr-1 ml-1"><strong>{{user && user.email}}</strong></li>
                <li class="mr-1 ml-1">
                  <b-button
                    variant="primary"
                    pill
                    size="sm"
                    @click="launchContactFormModal()">
                    Contact Support
                  </b-button>
                </li>
                <!-- <li>
                  <a href="/monitor">
                    <i class="icon-bell" style="font-size:18px"></i>
                  </a>
                  <span class="badge badge-danger badge-pill">0</span>

                </li> -->
                <!-- <li class="mr-1 ml-1">
                  <a href="/monitor">
                    <i class="fa fa-hourglass-start" style="font-size:18px"></i>
                  </a> -->
                  <!-- <span class="badge badge-danger badge-pill">0</span> -->
                <!-- </li> -->
              </ul>
            </div>
          </div>
        
        </div>
        <div class="container-fluid p-0">
          <router-view/>
        </div>
      </main>
    </div>
    <downloader/>

    <contact-support-modal
      :key="`contact-${modalKey}`"
      :shown="isContactSupportModalOpen"
      @success="messageSubmitSuccess"
      @close="isContactSupportModalOpen = false"/>
  </div>
</template>

<script>
  import nav from '@/_nav';
  import {
    Header as AppHeader,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarNavDivider,
    SidebarToggler
  } from '@coreui/vue';
  import {hasAllRequiredEntities} from '../utils';
  import Downloader from '../components/Downloader';
  import NotificationBell from 'vue-notification-bell'
  import {BRAND, IS_BETA} from '../localization';
  import ContactSupportModal from '../components/ContactSupportModal';


  export default {
    name: 'full',
    components: {
      Downloader,
      AppHeader,
      AppSidebar,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarNavDivider,
      NotificationBell,
      ContactSupportModal
    },
    mounted(){
     
      if(!!this.$store.state.general.user.free_trial && !!this.$store.state.general.user.free_trial_days_left){
        this.free_days_left = this.$store.state.general.user.free_trial_days_left;
      } 
    },
    data() {
      return {
        nav: nav.items.filter(x => IS_BETA || !x.beta),
        brand: BRAND,
        isContactSupportModalOpen: false,
        modalKey: 1,
        free_days_left : null,
      };
    },
    computed: {
      name() {
        return this.$route.name;
      },
      list() {
        return this.$route.matched.filter(route => route.name || route.meta.label);
      },
      user() {
        return this.$store.state.general.user;
      }
    },

    methods: {
      renewModalKey() {
        this.modalKey = this.modalKey + 1;
      },

      assetPath(asset) {
        return require('../assets/' + asset);
      },

      launchContactFormModal() {
        this.isContactSupportModalOpen = true;
      },

      messageSubmitSuccess() {
        this.isContactSupportModalOpen = false;
        this.$bvToast.toast('Your message has been sent successfully! We will respond as soon as possible.', {
          title: 'Successful',
          autoHideDelay: 5000000,
          variant: 'success',
          solid: true
        });
      }
    }
  };
</script>

<style scoped>
  ul li{
    display: inline;
  }
</style>
